import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://sharif-qasrawi.firebaseio.com/',
});

export default instance;